import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  OutlinedInput,
  Switch,
  Button,
  InputLabel,
  BottomNavigation,
  BottomNavigationAction, ListSubheader
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { DateTimeInput, useRedirect } from "react-admin";
import generateToken from "../../utils/generateToken";
import globalStyles from "../../utils/globalStyles";
import axios from "axios";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useTheme } from "@mui/material/styles";
import legolasApi from "../../api/legolas";
import { DesktopTimePicker } from "@mui/x-date-pickers";
import "../coupon/style.css";
import { type } from "@testing-library/user-event/dist/type";
import legolasConfig from "../../api/legolas";
import { get, isEmpty, isNull, isUndefined } from "lodash";

function AddCoupon(props) {
  const [actionTab, setActiontab] = React.useState(1);
  const { handleSubmit, control, reset, getValues, formState: { errors }, setError, setValue } = useForm({
    defaultValues: {
      discountAmountAction: "",
      minAmountAction: "",
      maxDiscountAction: "",
      // maxDiscountAmountAction:"",
      maxQtyXAction: "",
      maxQtyYAction: "",
      active: false,
      visibleOnCouponList: false,
      autoApplyCoupon: false,
      applyToShippingAmount: false,
      rule_name: "",
      coupon_code: "",
      desc_en: "",
      desc_ar: "",
      error_ar: "",
      error_en: "",
      usagePerCustomer: 0,
      usagePerCoupon: 0,
      inPercentage: false,
      onlyforApp: false,
      showInPdpPage: false,
      coupon_provider: "DEFAULT",
      promo_code: "",
      coupon_type: "",
      priority: 0,
      exclude_discounted_product_condition: [],
      exclude_discounted_product_action: [],

    },
  });
  const [dobValue, setDobValue] = React.useState(dayjs(new Date()));
  const [fromDate, setFromDate] = React.useState(dayjs(new Date()));
  const [toDate, setToDate] = React.useState(dayjs(new Date()));
  const [conditions, setConditionsArray] = React.useState([]);
  const [categories, setCategoriesArray] = React.useState([]);
  const [actionCategories, setActionCategoriesArray] = React.useState([]);
  const [brand, setBrandArray] = React.useState([]);
  const [actionBrand, setActionBrandArray] = React.useState([]);
  const [attributeSet, setAttributeSetArray] = React.useState([]);
  const [actionAttributeSet, setActionAttributeSetArray] = React.useState([]);
  const [paymentMethod, setPaymentMethodArray] = React.useState([]);
  const [shippingMethod, setShippingMethodArray] = React.useState([]);
  const [shippingPostcode, setShippingPostcodeArray] = React.useState([]);
  const [shippingState, setshippingStateArray] = React.useState([]);
  const [shippingRegion, setShippingRegionArray] = React.useState([]);
  const [shippingCountry, setShippingCountryArray] = React.useState([]);
  const [actionPaymentMethod, setActionPaymentMethodArray] = React.useState([]);
  const [actionShippingMethod, setActionShippingMethodArray] = React.useState(
    []
  );
  const [actionShippingPostcode, setActionShippingPostcodeArray] =
    React.useState([]);
  const [actionsShippingState, setActionsShippingStateArray] = React.useState(
    []
  );
  const [actionShippingRegion, setActionShippingRegionArray] = React.useState(
    []
  );
  const [actionShippingCountry, setActionShippingCountryArray] = React.useState(
    []
  );
  const [categoryOperator, setCategoryOperator] = React.useState("is one of");
  const [categoryDropdown, setCategoryDropdownArray] = React.useState([]);
  const [brandOperator, setBrandOperator] = React.useState("is one of");
  const [brandDropdown, setBrandDropdownArray] = React.useState([]);
  const [paymentMethodOperator, setPaymentMethodOperator] =
    React.useState("is one of");
  const [paymentMethodDropdown, setPaymentMethodDropdownArray] = React.useState(
    []
  );
  const [actionPaymentMethodOperator, setActionPaymentMethodOperator] =
    React.useState("is one of");
  const [actionPaymentMethodDropdown, setActionPaymentMethodDropdownArray] =
    React.useState([]);
  const [shippingMethodOperator, setShippingMethodOperator] =
    React.useState("is one of");
  const [shippingMethodDropdown, setShippingMethodDropdownArray] =
    React.useState([]);
  const [shippingPostCodeOperator, setShippingPostCodeOperator] =
    React.useState("is one of");
  const [shippingPostCodeDropdown, setShippingPostCodeArray] = React.useState(
    []
  );
  const [shippingStateOperator, setShippingStateOperator] =
    React.useState("is one of");
  const [shippingStateDropdown, setShippingStateArray] = React.useState([]);
  const [shippingRegionOperator, setShippingRegionOperator] =
    React.useState("is one of");
  const [shippingRegionDropdown, setShippingRegionDropdownArray] =
    React.useState([]);
  const [shippingCountryOperator, setShippingCountryOperator] =
    React.useState("is one of");
  const [shippingCountryDropdown, setShippingCountryDropdownArray] =
    React.useState([]);
  const [actionShippingMethodOperator, setActionShippingMethodOperator] =
    React.useState("is one of");
  const [actionShippingMethodDropdown, setActionShippingMethodDropdownArray] =
    React.useState([]);
  const [actionShippingPostCodeOperator, setActionShippingPostCodeOperator] =
    React.useState("is one of");
  const [actionShippingPostCodeDropdown, setActionShippingPostCodeArray] =
    React.useState([]);
  const [actionShippingStateOperator, setActionShippingStateOperator] =
    React.useState("is one of");
  const [actionShippingStateDropdown, setActionShippingStateArray] =
    React.useState([]);
  const [actionShippingRegionOperator, setActionShippingRegionOperator] =
    React.useState("is one of");
  const [actionShippingRegionDropdown, setActionShippingRegionDropdownArray] =
    React.useState([]);
  const [actionShippingCountryOperator, setActionShippingCountryOperator] =
    React.useState("is one of");
  const [actionShippingCountryDropdown, setActionShippingCountryDropdownArray] =
    React.useState([]);
  const [applyRuleAction, setApplyRuleAction] = React.useState(
    "Fixed amount discount"
  );
  const [isPercentage, setIsPercentage] = React.useState(
    false
  );
  //const [conditionType, setConditionType] = React.useState("All");
  const [conditionType, setConditionType] = React.useState("Any");
  const [conditionBoolean, setConditionBoolean] = React.useState(true);
  const [attributeSetOperator, setAttributeSetOperator] = React.useState("is one of");
  const [AttributeSetDropdown, setAttributeSetDropdownArray] = React.useState(
    []
  );
  const [attributeSetOperatorAction, setAttributeSetOperatorAction] =
    React.useState("is one of");
  const [AttributeSetDropdownAction, setAttributeSetDropdownArrayAction] =
    React.useState([]);
  const [brandOperatorAction, setBrandOperatorAction] = React.useState("is one of");
  const [brandDropdownAction, setBrandDropdownArrayAction] = React.useState([]);
  const [categoryOperatorAction, setCategoryOperatorAction] =
    React.useState("is one of");
  const [categoryDropdownAction, setCategoryDropdownArrayAction] =
    React.useState([]);
  const theme = useTheme();
  const [conditionValue, setConditionValue] = React.useState([]);
  const [actionValue, setActionValue] = React.useState([]);
  const [toTime, setToTime] = React.useState(dayjs(new Date()));
  const [skus, setSkusArray] = React.useState([]);
  const [skuOperator, setSkuOperator] = React.useState("is one of");
  const [actionSkus, setActionSkuArray] = React.useState([]);
  const [actionSkusOperator, setActionSkuOperator] = React.useState('is one of');
  const [price, setPriceValue] = React.useState("0");
  const [priceOperator, setPriceOperator] = React.useState("eq");
  const [actionPrice, setActionPriceArray] = React.useState([]);
  const [actionPriceOperator, setActionPriceOperator] = React.useState('eq');
  const [cartPrice, setCartPriceValue] = React.useState("0");
  const [cartPriceOperator, setCartPriceOperator] = React.useState("eq");
  const [actionCartPrice, setActionCartPriceArray] = React.useState([]);
  const [actionCartPriceOperator, setActionCartPriceOperator] = React.useState(
    "eq"
  );
  const [cartSubTotalExclTax, setCartSubTotalExclTaxValue] =
    React.useState("0");
  const [cartSubTotalExclTaxOperator, setCartSubTotalExclTaxOperator] =
    React.useState("eq");


  const [actionCartSubTotalExclTax, setActionCartSubTotalExclTaxArray] = React.useState("0");
  const [actioncartSubTotalExclTaxOperator, setActionCartSubTotalExclTaxOperator] = React.useState("eq");


  const [cartSubTotalInclTax, setCartSubTotalInclTaxValue] =
    React.useState([]);
  const [cartSubTotalInclTaxOperator, setCartSubTotalInclTaxOperator] =
    React.useState([]);
  const [actionCartSubTotalInclTax, setActionCartSubTotalInclTaxArray] =
    React.useState("0");
  const [
    actioncartSubTotalInclTaxOperator,
    setActionCartSubTotalInclTaxOperator,
  ] = React.useState("eq");
  const [totalWeight, setTotalWeightValue] = React.useState("0");
  const [totalWeightOperator, setTotalWeightOperator] = React.useState("eq");
  const [actionTotalWeight, setActionTotalWeightArray] = React.useState([]);
  const [actionTotalWeightOperator, setActionTotalWeightOperator] =
    React.useState([]);
  const [toDateError, setToDateError] = React.useState('');
  const [channelData, setChannelData] = React.useState([]);
  console.log(channelData);

  const [channelValue, setChannelValue] = React.useState([]);
  const [channelError, setChannelError] = React.useState('');
  const [reviewCoupon, setReviewCoupon] = React.useState(false);
  const [couponProvider, setCouponProvider] = useState('DEFAULT'); // State to track coupon type
  const [couponType, setCouponType] = useState(null);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const redirect = useRedirect();

  const redirectToList = () => {
    redirect("/cart-price-rule");
  };
  const handleReset = () => {
    window.location.reload();
  }
  
  const controllerLabel = {
    margin: "10px 5%",
    fontSize: "20px",
    fontWeight: "bold",
    color: "black",
  };
  const controllerFields = {
    margin: "10px 5%",
    width: "500px",
    borderBottom: "2px solid #2b3f7a",
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: "#fff !important",
    },
  };

  const controllerSwitch = {
    margin: "10px 5%",
    // width: '500px',
    borderBottom: "2px solid #2b3f7a",
    borderRadius: 0,
    "& .MuiFilledInput-input": {
      backgroundColor: "#fff !important",
    },
  };

  const controllerDropdowns = {
    margin: "10px 5%",
    width: "500px",
    border: "2px solid #2b3f7a",
    borderRadius: 0,
  };
  const dropDownWithInput = {
    margin: "10px 0% 10px 0%",
    width: "100px",
    height: "52px",
    border: "2px solid #2b3f7a",
    borderRadius: 0,
  };

  const inputwithDropdown = {
    margin: "10px 0% 10px 5%",
    width: "400px",
    border: "2px solid #2b3f7a",
    // borderRadius: 0,
    // "& .MuiFilledInput-input": {
    //   backgroundColor: "#fff !important",
    // },
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getStyles(name, conditionValue, theme) {
    return {
      fontWeight:
        conditionValue.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }
  React.useEffect(() => {
    getChannel();
  }, [])

  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
        //setChannelData(res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }
  const names = [
    "Category",
    "Brand",
    "AttributeSet",
    "Sku",
    "Price",
    "Cart Price",
    "Cart Sub Total (Excl Tax)",
    "Cart Sub Total (Incl Tax)",
    "Total Weight",
    "Payment Method",
    "Shipping Method",
    "Shipping PostCode",
    "Shipping Region",
    "Shipping State",
    "Shipping Country",
    "Qty",
  ];
  const namesAction = [
    "Category",
    "Brand",
    "AttributeSet",
    "Sku",
    "Price",
    "Cart Price",
    "Cart Sub Total (Excl Tax)",
    "Cart Sub Total (Incl Tax)",
    "Total Weight",
    "Payment Method",
    "Shipping Method",
    "Shipping PostCode",
    "Shipping Region",
    "Shipping State",
    "Shipping Country",
    "Qty",
  ];

  const actionRules = [
    "Percent of product price discount(Discount amount in %)",
    "Fixed amount discount",
    "Fixed amount discount for whole cart",
    "Buy X get Y free (discount amount is Y)",
    "Buy X For Price of Y",
    "Discount UP-TO (Discount amount in %)"
  ];

  // const filteredActionRules = actionRules.filter(
  //   (rule) => rule === "Fixed amount discount" || rule === "Fixed amount discount for whole cart" || rule === "Discount UP-TO (Discount amount in %)"
  // );

const filteredActionRules = actionRules.filter(
    (rule) => rule === "Fixed amount discount for whole cart");

  useEffect(() => {
    if (couponProvider === "NASHNAK") {
      const defaultAction = "Fixed amount discount for whole cart";
      const defaultCondition = "Cart Sub Total (Incl Tax)";

      setValue("action_rule", defaultAction);
      setApplyRuleAction(defaultAction);

      setValue("conditions", [defaultCondition]);
      setConditionValue([defaultCondition]);
    }
  }, [couponProvider]);

  
const couponRuleConfig = {
  "Buy X get Y free (discount amount is Y)": {
    conditionRequired: ["Sku", "Category"],
    actionRequired: [],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: true,
      discountPercentage: true,
      discountAmount: true,
      totalAmount: false,
    },
  },

  "Buy X get Y free (different SKU)": {
    conditionRequired: ["Sku", "Category"],
    actionRequired: ["Sku", "Category"],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: true,
      discountPercentage: true,
      discountAmount: true,
      totalAmount: false,
    },
  },

  "Buy X For Price of Y": {
    conditionRequired: ["Sku", "Category"],
    actionRequired: ["Sku", "Category"],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: false,
      discountPercentage: false,
      discountAmount: false,
      totalAmount: true,
    },
  },

  "Percent of product price discount(Discount amount in %)": {
    conditionRequired: ["Sku", "Category"],
    actionRequired: ["Sku", "Category"],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: false,
      discountPercentage: true,
      discountAmount: true,
      totalAmount: false,
    },
  },

  "Fixed amount discount": {
    conditionRequired: ["Sku", "Category"],
    actionRequired: ["Sku", "Category"],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: false,
      discountPercentage: true,
      discountAmount: true,
      totalAmount: false,
    },
  },

  "Fixed amount discount for whole cart": {
    conditionRequired: ["Cart Sub Total (Excl Tax)"],
    actionRequired: [],
    actionOptional: [],
    fields: {
      xQty: true,
      yQty: false,
      discountPercentage: true,
      discountAmount: true,
      totalAmount: false,
    },
  },
};

  const saveCoupon = () => {

    if (couponProvider === "DEFAULT" || couponProvider === "NASHNAK") {

      if (channelValue.length === 0) {
        setChannelError("Please select at least one channel");
        return;
      } else {
        setChannelError("");
      }
     
      let valuesData;
      let data;
      const fieldVals = getValues();
       if (!fieldVals.desc_en?.trim() || !fieldVals.desc_ar?.trim()) {
        alert("Please provide both English and Arabic descriptions");
        return;
      }

      // if (!fieldVals.error_en?.trim() || !fieldVals.error_ar?.trim()) {
      //   alert("Please provide both English and Arabic error messages");
      //   return;
      // }

      console.log("fieldVals");
      console.log(fieldVals);
      let fromdate = Date.parse(fromDate);
      let todate = Date.parse(toDate);
      console.log("fromdate", fromdate);
      console.log("todate", todate);
      data = {
        firstname: fieldVals.firstname,
        lastname: fieldVals.lastname,
        email: fieldVals.email,
        allow_login: 1,
        group_id: fieldVals.group,
        website_id: 0,
        dob: dobValue ? dobValue : undefined,
      };
      if (fromdate !== todate) {
        valuesData = {
          couponName: fieldVals.rule_name,
          couponCode: fieldVals.coupon_code,
          promoCode: fieldVals.promo_code ? fieldVals.promo_code : null,
          couponProvider: fieldVals.coupon_provider,
          couponType: fieldVals.coupon_type ? fieldVals.coupon_type : null,
          // exclude_discounted_product: fieldVals.exclude_discounted_product || [],
          exclude_discounted_products: {
            actionProduct: fieldVals.exclude_discounted_action_product || [],
            conditionProduct: fieldVals.exclude_discounted_condition_product || [],
          },

          desc: {
            "en-SA": fieldVals.desc_en,
            "ar-SA": fieldVals.desc_ar,
          },
          error: {
            "en-SA": fieldVals.error_en,
            "ar-SA": fieldVals.error_ar,
          },

          desc: { "en-SA": fieldVals.desc_en, "ar-SA": fieldVals.desc_ar, },
         // error: { "en-SA": fieldVals.error_en, "ar-SA": fieldVals.error_ar, },
          active: fieldVals.active,
          visibleOnCouponList: fieldVals.visibleOnCouponList,
          autoApplyCoupon: fieldVals.autoApplyCoupon,
          showInPdpPage: fieldVals.showInPdpPage,
          priority: fieldVals.priority,
          onlyforApp: fieldVals.onlyforApp,
          applyToShippingAmount: fieldVals.applyToShippingAmount,
          active: fieldVals.active,
          conditionType: conditionType,
          conditionValue: conditionBoolean,
          config: {
            usagePerCoupon: fieldVals.usagePerCoupon && fieldVals.usagePerCoupon !== null? fieldVals.usagePerCoupon : 0,
            usagePerCustomer: fieldVals.usagePerCustomer && fieldVals.usagePerCustomer !== null?fieldVals.usagePerCustomer : 0,
            timesUsed: null,
            customerEmails:[]
          },
          couponValid: {
            fromDate: fromDate,
            toDate: toDate,
          },
          actionRules: {
            isPercentage: isPercentage,
            applyRule: applyRuleAction,
            xQty: fieldVals.maxQtyXAction,
            yQty: fieldVals.maxQtyYAction,
            discountAmount: fieldVals.discountAmountAction,
            // maxDiscountAmount: fieldVals.maxDiscountAmountAction,
            minAmount: fieldVals.minAmountAction,
            maxDiscountAmount: fieldVals.maxDiscountAction,
            totalAmount: fieldVals.totalAmountAction,
            discountPercentage: fieldVals.discountAmountAction,
            applyToShippingAmount: fieldVals.applyToShippingAmount,
            discardSubsequentRules: true,
          },
          conditionRules: {},
          conditions: conditionValue,
          actions: actionValue,
          channels: channelValue,
          reviewCoupon: reviewCoupon
        };
        setToDateError("")

      }
      else {
        setToDateError("From Date must be different from To Date")
        return;
      }

      if (conditionValue.includes("Category")) {
        if (!categories || categories.length === 0) {
          return;
        } else {
          console.log(categoryOperator);
          console.log(categories);
          valuesData.conditionRules.category = {
            operator: categoryOperator,
            value: categories,
          };
        }
      }
      if (conditionValue.includes("Brand")) {
        if (!brand || brand.length === 0) {
          return;
        } else {
          valuesData.conditionRules.globalBrand = {
            operator: brandOperator,
            value: brand,
          };
        }
      }
      if (conditionValue.includes("AttributeSet")) {
        if (!attributeSet || attributeSet.length === 0) {
          return;
        } else {
          valuesData.conditionRules.attributeSet = {
            operator: attributeSetOperator,
            value: attributeSet,
          };
        }
      }

      if (conditionValue.includes("Sku")) {
        if (!skus || skus.length === 0) {
          return;
        } else {
          valuesData.conditionRules.sku = {
            operator: skuOperator,
            value: skus,
          };
        }
      }
      if (conditionValue.includes("Price")) {
        if (!price && price === "0") {
          return;
        } else {
          valuesData.conditionRules.price = {
            operator: priceOperator,
            value: price,
          };
        }

      }
      if (conditionValue.includes("Cart Price")) {
        if (!cartPrice && cartPrice === "0") {
          return
        }
        else {
          valuesData.conditionRules.cartPrice = {
            operator: cartPriceOperator,
            value: cartPrice,
          };
        }

      }
      if (conditionValue.includes("Cart Sub Total (Excl Tax)")) {
        if (!cartSubTotalExclTax && cartSubTotalExclTax === "0") {
          return;
        }
        else {
          valuesData.conditionRules.cartSubTotalExclTax = {
            operator: cartSubTotalExclTaxOperator,
            value: cartSubTotalExclTax,
          };
        }

      }
      if (conditionValue.includes("Cart Sub Total (Incl Tax)")) {
        if (!cartSubTotalInclTax && cartSubTotalInclTax === "0") {
          return;
        }
        else {
          valuesData.conditionRules.cartSubTotalInclTax = {
            operator: cartSubTotalInclTaxOperator,
            value: cartSubTotalInclTax,
          };
        }

      }
      if (conditionValue.includes("Total Weight")) {
        if (!totalWeight && totalWeight === "0") {
          return;
        } else {
          valuesData.conditionRules.totalWeight = {
            operator: totalWeightOperator,
            value: totalWeight,
          };
        }
      }
      if (conditionValue.includes("Payment Method")) {
        if (!paymentMethod && paymentMethod.length == 0) {
          return;
        } else {
          valuesData.conditionRules.paymentMethod = {
            operator: paymentMethodOperator,
            value: paymentMethod,
          };
        }
      }

      if (conditionValue.includes("Shipping Method")) {
        if (!shippingMethod && shippingMethod.length == 0) {
          return;
        } else {
          valuesData.conditionRules.shippingMethod = {
            operator: shippingMethodOperator,
            value: shippingMethod,
          };
        }

      }
      if (conditionValue.includes("Shipping PostCode")) {
        if (!shippingPostcode && shippingPostcode.length == 0) {
          return;
        }
        else {
          valuesData.conditionRules.shippingPostcode = {
            operator: shippingPostCodeOperator,
            value: shippingPostcode,
          };
        }

      }
      if (conditionValue.includes("Shipping State")) {
        if (!shippingState && shippingState.length == 0) {
          return;
        } else {
          valuesData.conditionRules.shippingState = {
            operator: shippingStateOperator,
            value: shippingState,
          };
        }

      }
      if (conditionValue.includes("Shipping Country")) {
        if (!shippingCountry && shippingCountry.length == 0) {
          return;
        } else {
          valuesData.conditionRules.shippingCountry = {
            operator: shippingCountry,
            value: shippingCountry,
          };
        }

      }

      // action rules
      if (actionValue.includes("Category")) {
        if (!actionCategories && actionCategories.length == 0) {
          return;
        } else {
          console.log(categoryOperatorAction);
          console.log(actionCategories);
          valuesData.actionRules.category = {
            operator: categoryOperatorAction,
            value: actionCategories,
          };
        }

      }
      if (actionValue.includes("Brand")) {
        if (!actionBrand && actionBrand.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.globalBrand = {
            operator: brandOperatorAction,
            value: actionBrand,
          };
        }

      }
      if (actionValue.includes("AttributeSet")) {
        if (!actionAttributeSet && actionAttributeSet.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.attributeSet = {
            operator: attributeSetOperatorAction,
            value: actionAttributeSet,
          };
        }

      }
      if (actionValue.includes("Sku")) {
        if (!actionSkus && actionSkus.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.sku = {
            operator: actionSkusOperator,
            value: actionSkus,
          };
        }

      }
      if (actionValue.includes("Price")) {
        if (!actionPrice && actionPrice.length == 0) {
          return;
        } else {
          valuesData.actionRules.price = {
            operator: actionPriceOperator,
            value: actionPrice,
          };
        }

      }
      if (actionValue.includes("Cart Price")) {
        if (!actionCartPrice && actionCartPrice.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.cartPrice = {
            operator: actionCartPriceOperator,
            value: actionCartPrice,
          };
        }
      }
      if (actionValue.includes("Cart Sub Total (Excl Tax)")) {
        if (!actionCartSubTotalExclTax && actionCartSubTotalExclTax == "0") {
          return;
        } else {
          valuesData.actionRules.cartSubTotalExclTax = {
            operator: actioncartSubTotalExclTaxOperator,
            value: actionCartSubTotalExclTax,
          };
        }

      }
      if (actionValue.includes("Cart Sub Total (Incl Tax)")) {
        if (!actionCartSubTotalInclTax && actionCartSubTotalInclTax == "0") {
          return;
        }
        else {
          valuesData.actionRules.cartSubTotalInclTax = {
            operator: actioncartSubTotalInclTaxOperator,
            value: actionCartSubTotalInclTax,
          };
        }

      }
      if (actionValue.includes("Total Weight")) {
        if (!actionTotalWeight && actionTotalWeight.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.totalWeight = {
            operator: actionTotalWeightOperator,
            value: actionTotalWeight,
          };
        }

      }
      if (actionValue.includes("Payment Method")) {
        if (!actionPaymentMethod && actionPaymentMethod.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.paymentMethod = {
            operator: actionPaymentMethodOperator,
            value: actionPaymentMethod,
          }
        }
        ;
      }
      if (actionValue.includes("Shipping Method")) {
        if (!actionShippingMethod && actionShippingMethod.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.shippingMethod = {
            operator: actionShippingMethodOperator,
            value: actionShippingMethod,
          };
        }

      }
      if (actionValue.includes("Shipping PostCode")) {
        if (!actionShippingPostcode && actionShippingPostcode.length == 0) {
          return;
        } else {
          valuesData.actionRules.shippingPostcode = {
            operator: actionShippingPostCodeOperator,
            value: actionShippingPostcode,
          };
        }

      }
      if (actionValue.includes("Shipping State")) {
        if (!actionsShippingState && actionsShippingState.length == 0) {
          return;
        } else {
          valuesData.actionRules.shippingState = {
            operator: actionShippingStateOperator,
            value: actionsShippingState,
          };
        }

      }
      if (actionValue.includes("Shipping Country")) {
        if (!actionShippingCountry && actionShippingCountry.length == 0) {
          return;
        }
        else {
          valuesData.actionRules.shippingCountry = {
            operator: actionShippingCountry,
            value: actionShippingCountry,
          };
        }

      }

      console.log("payloaddata ", valuesData);

      const signedToken = generateToken(data);
      // console.log("all form data",valuesData);

      axios
        .post(`${legolasConfig.url}/admin/coupon/create`, valuesData, {
          headers: {
            Authorization: `Bearer ${signedToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("coupon added");
          console.log(res);
          alert("Coupon Code Added");
          if (res) {
            redirect("/cart-price-rule");
          }
        })
        .catch((err) => {
          const message =
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.message ||
            "Something went wrong. Please try again.";

          alert(message);
          console.error("Create coupon error:", err);
          //alert(err.response.data.message)
          //console.log(err)
        });
    };
  }
  const handleChange = (event, name) => {
    switch (name) {
      case "fromDate": {
        setFromDate(event);

        break;
      }
      case "toDate": {
        setToDate(event);
        setToDateError("")
        break;
      }
      case "actionRule": {
        const {
          target: { value },
        } = event;
        setApplyRuleAction(value);
        break;
      }
      case "isPercentage": {
        const {
          target: { value },
        } = event;
        setIsPercentage(value);
        break;
      }
      case "conditionType": {
        const {
          target: { value },
        } = event;
        setConditionType(value);
        break;
      }
      case "conditionBoolean": {
        const {
          target: { value },
        } = event;
        setConditionBoolean(value);
        break;
      }
      case "reviewCoupon": {
        const {
          target: { value },
        } = event;
        setReviewCoupon(value);
        break;
      }

    }
  };

  const handleOperatorChange = (event, name) => {
    const {
      target: { value },
    } = event;

    console.log("actionexcl", value)
    switch (name) {
      case "categoryOperator": {
        setCategoryOperator(value);
        break;
      }
      case "categoryOperatorAction": {
        setCategoryOperatorAction(value);
        break;
      }
      case "brandOperator": {
        setBrandOperator(value);
        break;
      }
      case "attributeSetOperator": {
        setAttributeSetOperator(value);
        break;
      }
      case "priceOperator": {
        setPriceOperator(value);
        break;
      }
      case "InclTax": {
        setCartSubTotalInclTaxOperator(value);
        break;
      }
      case "ExclTax": {
        setCartSubTotalExclTaxOperator(value);
        break;
      }
      case "cartPriceOperator": {
        setCartPriceOperator(value);
        break;
      }
      case "skuOperator": {
        setSkuOperator(value);
        break;
      }
      case "paymentMethod": {
        setPaymentMethodOperator(value);
        break;
      }
      case "shippingMethod": {
        setShippingMethodOperator(value);
        break;
      }
      case "shippingRegion": {
        setShippingRegionOperator(value);
        break;
      }
      case "shippingPostCode": {
        setShippingPostCodeOperator(value);
        break;
      }
      case "shippingState": {
        setShippingStateOperator(value);
        break;
      }
      case "shippingCountry": {
        setShippingCountryOperator(value);
        break;
      }
      case "totalWeight": {
        setTotalWeightOperator(value);
        break;
      }
      case "actionBrandOperator": {
        setBrandOperatorAction(value);
        break;
      }
      case "actionAttributeSetOperator": {
        setAttributeSetOperatorAction(value);
        break;
      }
      case "actionPriceOperator": {
        setActionPriceOperator(value);
        break;
      }
      case "actionInclTax": {
        setActionCartSubTotalInclTaxOperator(value);
        break;
      }
      case "actionExclTax": {
        setActionCartSubTotalExclTaxOperator(value);
        break;
      }
      case "actionCartPriceOperator": {
        setActionCartPriceOperator(value);
        break;
      }
      case "actionSkuOperator": {
        setActionSkuOperator(value);
        break;
      }
      case "actionPaymentMethod": {
        setActionPaymentMethodOperator(value);
        break;
      }
      case "actionShippingMethod": {
        setActionShippingMethodOperator(value);
        break;
      }
      case "actionShippingRegion": {
        setActionShippingRegionOperator(value);
        break;
      }
      case "actionShippingPostCode": {
        setActionShippingPostCodeOperator(value);
        break;
      }
      case "actionShippingState": {
        setActionShippingStateOperator(value);
        break;
      }
      case "actionShippingCountry": {
        setActionShippingCountryOperator(value);
        break;
      }
      case "totalWeight": {
        setActionTotalWeightOperator(value);
        break;
      }
    }
  };

  const handleChannelChanges = (event) => {
    const {
      target: { value },
    } = event;
    setChannelValue(value)
    setCategoriesArray([])
    setAttributeSetArray([])
    setActionCategoriesArray([])
    setActionAttributeSetArray([])
  }
  const handleChanges = (event, type) => {
    const {
      target: { value },
    } = event;
    switch (type) {
      case "conditionValue": {
        setConditionValue(typeof value === "string" ? value.split(",") : value);
        break;
      }
      case "actionValue": {
        setActionValue(typeof value === "string" ? value.split(",") : value);
        break;
      }
    }
  };
  const loadConditionValue = (event, type) => {
    console.log(conditionValue);
    switch (type) {
      case "conditionValue": {
        let data = {
          data: conditionValue,
        };
        axios
          .post(`${legolasApi.url}/admin/coupon/fields`, data)
          .then((res) => {
            console.log("order res: ", res);
            const data = res.data.data;
            if (conditionValue.includes("Category")) {
              setCategoryDropdownArray(data.category);
            }
            if (conditionValue.includes("Brand")) {
              setBrandDropdownArray(data.brand);
            }
            if (conditionValue.includes("AttributeSet")) {
              setAttributeSetDropdownArray(data.attributeSet);
            }
            // setTotalcount(count)
          })
          .catch((error) => console.log("Error in getting orders: ", error));
      }
      case "actionValue": {
        let data = {
          data: actionValue,
        };
        axios
          .post(`${legolasApi.url}/admin/coupon/fields`, data)
          .then((res) => {
            console.log("order res: ", res);
            const data = res.data.data;
            if (actionValue.includes("Category")) {
              setCategoryDropdownArrayAction(data.category);
            }
            if (actionValue.includes("Brand")) {
              setBrandDropdownArrayAction(data.brand);
            }
            if (actionValue.includes("AttributeSet")) {
              setAttributeSetDropdownArrayAction(data.attributeSet);
            }
            // setTotalcount(count)
          })
          .catch((error) => console.log("Error in getting orders: ", error));
      }
    }
  };
  const handleConditionChanges = (event, type) => {
    const {
      target: { value },
    } = event;
    console.log("event", event)

    switch (type) {
      case "category": {

        setCategoriesArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "brand": {
        setBrandArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        setError("brand", '');
        break;
      }
      case "attributeSet": {

        setAttributeSetArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "sku": {
        const val = value.replace(/[,@!%^&*$#| "']+/g, ",").trim(',');
        setSkusArray(
          // On autofill we get a stringified value.
          typeof val === "string" ? val.split(",") : val
        );
        setError("sku", '');
        break;
      }
      case "price": {
        setPriceValue(value);
        break;
      }
      case "cartPrice": {
        setCartPriceValue(value);
        break;
      }
      case "InclTax": {
        setCartSubTotalInclTaxValue(value);
        break;
      }
      case "ExclTax": {
        setCartSubTotalExclTaxValue(value);
        break;
      }
      case "totalWeight": {
        setTotalWeightValue(value);
        break;
      }
      case "paymentMethod": {
        setPaymentMethodArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "shippingMethod": {
        setShippingMethodArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "shippingPostcode": {
        setShippingPostCodeArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionAttributeSet": {
        setActionAttributeSetArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionCategory": {
        setActionCategoriesArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionBrand": {
        setActionBrandArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionSku": {
        const val = value.replace(/[,@!%^&*$#| "']+/g, ",").trim(',')
        setActionSkuArray(
          // On autofill we get a stringified value.
          typeof val === "string" ? val.split(",") : val
        );
        break;
      }
      case "actionPrice": {
        setActionPriceArray(value);
        break;
      }
      case "actionCartPrice": {
        setActionCartPriceArray(value);
        break;
      }
      case "actionInclTax": {
        setActionCartSubTotalInclTaxArray(value);
        break;
      }
      case "actionExclTax": {
        setActionCartSubTotalExclTaxArray(value);
        break;
      }
      case "actionTotalWeight": {
        setActionTotalWeightArray(value);
        break;
      }
      case "actionPaymentMethod": {
        setActionPaymentMethodArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionShippingMethod": {
        setActionShippingMethodArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
      case "actionShippingPostcode": {
        setActionShippingPostCodeArray(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
        break;
      }
    }
  };

  const handleProviderChange = (event, field) => {
    const selectedProvider = event.target.value;
    setCouponProvider(selectedProvider);
    field.onChange(selectedProvider);
    const couponTypeValue = selectedProvider === "NASHNAK" ? "GENERIC" : null;
    setValue("coupon_type", couponTypeValue); // Reset or set to GENERIC

    const reviewCouponValue = selectedProvider === "NASHNAK" ? false : null;
    setReviewCoupon(reviewCouponValue); // Update local component state
    setValue("review_coupon", reviewCouponValue); // Update form field value
  };
  const handleTypeChange = (event, field) => {
    const selectedType = event.target.value;
    field.onChange(selectedType);
  };


  return (
    <React.Fragment>
      <Box
        sx={{
          margin: "30px 50px",
          "& .MuiTypography-root": {
            fontSize: "2.5rem",
            fontWeight: 400,
            color: "#000",
          },
        }}
      >
        <Typography variant="h5">New Coupon</Typography>
      </Box>

      <form className={"formClass"} onSubmit={handleSubmit(saveCoupon)}>
        <Box>
          <BottomNavigation
            showLabels
            value={actionTab}
            onChange={(event, newValue) => {
              //  setValue(newValue);
              setActiontab(newValue);
            }}
            sx={{
              "& .MuiBottomNavigationAction-root": {
                backgroundColor: globalStyles.colors.white,
                border: "2px solid #2b3f7a !important",
                color: "#2b3f7a",
                margin: "5px 10px !important",
                padding: "0 !important",
                fontSize: "0.9rem !important",
                "&:hover": {
                  transform: "scale(1.1, 1.1)",
                },
                "& .Mui-selected": {
                  color: "#2b3f7a",
                  transition: "none",
                  fontSize: "0.9rem",
                },
              },
            }}
          >
            <BottomNavigationAction label="Back" onClick={redirectToList} />
            <BottomNavigationAction label="Reset" onClick={handleReset} />
            {/* <BottomNavigationAction label="Save and Continue Edit" onClick={saveAndContinue}/> */}
            <BottomNavigationAction
              label="Save Coupon"
              sx={{
                backgroundColor: "#2b3f7a !important",
                border: "2px solid #2b3f7a !important",
                color: "#fff !important",
                "& .Mui-selected": {
                  color: "#fff !important",
                },
              }}
              onClick={saveCoupon}
              type="submit"
            />
          </BottomNavigation>
        </Box>
        <div>

          <Controller
            name="coupon_provider"
            control={control}
            defaultValue="DEFAULT" // Ensure defaultValue is provided for Controller
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <InputLabel sx={controllerLabel} id="coupon-provider-label">
                  Coupon Provider
                </InputLabel>
                <Select
                  {...field}
                  labelId="coupon-provider-label"
                  id="coupon-type-select"
                  value={couponProvider}
                  onChange={(event) => handleProviderChange(event, field)}
                  label="Coupon Provider"
                  sx={controllerDropdowns}
                >
                  <MenuItem value="DEFAULT">DEFAULT</MenuItem>
                  <MenuItem value="NASHNAK">NASHNAK</MenuItem>
                </Select>
              </div>
            )}
            sx={{ margin: "0px 30px" }}
          />

          {couponProvider === 'DEFAULT' && (
            <>
              <Controller
                name="active"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Active
                    </InputLabel>
                    <Switch {...field} label="Active" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="visibleOnCouponList"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Visible on Coupon List
                    </InputLabel>
                    <Switch {...field} label="visible" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ margin: "500px" }}
              />
              <Controller
                name="onlyforApp"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Apply for App
                    </InputLabel>
                    <Switch {...field} label="Apply for App" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ margin: "500px" }}
              />
              <Controller
                name="applyToShippingAmount"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Apply To Shipping Amount
                    </InputLabel>
                    <Switch {...field} label="Active" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="showInPdpPage"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Show in PDP Page
                    </InputLabel>
                    <Switch {...field} label=" Show in PDP Page" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="autoApplyCoupon"
                control={control}
                defaultValue={false}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="auto-apply-coupon-label">
                      Auto Apply Coupon
                    </InputLabel>
                    <Switch {...field} checked={field.value} sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />

              <Controller
                name="priority"
                control={control}
                defaultValue={0}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="priority-select-label">
                      Priority
                    </InputLabel>
                    <Select
                      {...field}
                      labelId="priority-select-label"
                      id="priority-select"
                      label="Priority"
                      sx={controllerDropdowns}
                    >
                      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ width: "500px" }}
              />

              <Controller
                name="rule_name"
                control={control}
                rules={{ required: "Rule Name is required*" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Rule Name
                </InputLabel> */}
                    <TextField {...field} label="Rule Name" sx={{ ...controllerFields, paddingBottom: "0px" }}
                    // error={Boolean(errors.rule_name)} 
                    // helperText={errors.rule_name && errors.rule_name.message}
                    />

                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.rule_name && errors.rule_name.message}</span>
              <Controller
                name="coupon_code"
                control={control}
                rules={{ required: "Coupon Code is required*",
                          validate: (value) => value?.trim() ? true : "Coupon Code is required*",
                        }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      onBlur={(e) => {field.onChange(("" + e.target.value).toUpperCase().trim());
                      setValue( "coupon_code",("" + e.target.value).toUpperCase().trim(),{shouldValidate: true,shouldDirty: true,});
                      field.onBlur();
                      }}                  
                      onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
                      label="Coupon Code"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.coupon_code && errors.coupon_code.message}</span>
              <Controller
                name="desc_en"
                control={control}
                //rules={{ required: true }}
                rules={{ required: "English Description is required" }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      label="English Description"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_en && errors.desc_en.message}</span>
              <Controller
                name="desc_ar"
                control={control}
                //rules={{ required: true }}
                rules={{ required: "Arabic Description is required" }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      label="Arabic Description"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_ar && errors.desc_ar.message}</span>
              <Controller
                name="error_en"
                control={control}
                //rules={{ required: true }}
                //rules={{ required: "English Error Message is required" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message En
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="English Error Message"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
             <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.error_en && errors.error_en.message}</span>
              <Controller
                name="error_ar"
                control={control}
                //rules={{ required: true }}
                //rules={{ required: "Arabic Error Message is required" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message Ar
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Arabic Error Message"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.error_ar && errors.error_ar.message}</span>
              <Controller
                name="usagePerCustomer"
                control={control}
                //rules={{ required: true }}
                rules={{ required: "English Error Message is required" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message Ar
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Usage Per Customer"
                      type="number"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.error_en && errors.error_en.message}</span>
              <Controller
                name="usagePerCoupon"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message Ar
                </InputLabel> */}
                    <TextField
                      {...field}
                      type="number"
                      label="Usage Per Coupon"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="fromDate"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DateTimePicker
                      // label="From Date"
                      inputFormat="MM/DD/YYYY , HH:mm:ss"
                      value={fromDate}
                      disablePast
                      onChange={(date) => handleChange(date, "fromDate")}
                      renderInput={(params) => (
                        <div>
                          <InputLabel
                            sx={controllerLabel}
                            id="demo-simple-select-label"
                          >
                            From Date
                          </InputLabel>
                          <TextField {...params} sx={controllerFields} />
                        </div>
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="toDate"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DateTimePicker
                      inputFormat="MM/DD/YYYY , HH:mm:ss"
                      value={toDate}
                      disablePast
                      minDateTime={fromDate}
                      onChange={(date) => handleChange(date, "toDate")}
                      renderInput={(params) => (
                        <div>
                          <InputLabel
                            sx={controllerLabel}
                            id="demo-simple-select-label"
                          >
                            To Date
                          </InputLabel>
                          <TextField {...params} sx={controllerFields} />
                        </div>
                      )}

                    />

                  )}
                />
              </LocalizationProvider>
              {toDateError && <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>{toDateError}</span>}
              <Controller
                name="channel"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Channel
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={channelValue}
                      onChange={(value) => handleChannelChanges(value)}
                      // value={field.value || []}
                      // onChange={(e) => {
                      //   // field.onChange(e.target.value);
                      //   // setChannelValue(e.target.value);
                      //   handleChannelChanges(e);
                      // }}
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {channelData.map((name) => (
                        <MenuItem key={name._id} value={name._id}>
                          {name.name}
                        </MenuItem>
                      ))}

                    </Select>
                    {channelValue && channelValue.length === 0 && (
                      <p style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {channelError}</p>
                    )}
                  </div>

                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="review_coupon"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Review Coupon
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={reviewCoupon}
                      label="Review Coupon"
                      onChange={(value) => handleChange(value, "reviewCoupon")}
                      sx={controllerDropdowns}
                    >
                      <MenuItem value={true}>True</MenuItem>
                      <MenuItem value={false}>False</MenuItem>
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="condition_type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Condition Type
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={conditionType}
                      label="Condition Type"
                      onChange={(value) => handleChange(value, "conditionType")}
                      sx={controllerDropdowns}
                    >
                      {/* <MenuItem value={"All"}>All</MenuItem> */}
                      <MenuItem value={"Any"}>Any</MenuItem>
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="condition_boolean"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Condition Value
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={conditionBoolean}
                      label="Condition Value"
                      onChange={(value) => handleChange(value, "conditionBoolean")}
                      sx={controllerDropdowns}
                    >
                      <MenuItem value={true}>True</MenuItem>
                      <MenuItem value={false}>False</MenuItem>
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <div
                style={{ width: "100%", height: "5px", backgroundColor: "black" }}
              ></div>
              <Controller
                name="conditions"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Condition
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={conditionValue}
                      onChange={(value) => handleChanges(value, "conditionValue")}
                      onClose={(value) =>
                        loadConditionValue(value, "conditionValue")
                      }
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {names.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, conditionValue, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />

              {conditionValue.includes("Category") ? (
                <Controller
                  name="category"
                  control={control}
                  rules={{ required: "Please enter category value" }}
                  defaultValue={[]}
                  render={({ field }) => {
                    const selectedChannelIds = channelValue || [];
                    const filteredCategories = categoryDropdown.filter((category) =>
                      category.channelId?.some((id) => selectedChannelIds.includes(id))
                    );

                    return (
                      <div>
                        <InputLabel sx={controllerLabel} id="category-operator-label">
                          Select Category
                        </InputLabel>

                        {/* Category Operator */}
                        <Select
                          labelId="category-operator-label"
                          id="category-operator"
                          value={categoryOperator}
                          label="Category Operator"
                          onChange={(value) =>
                            handleOperatorChange(value, "categoryOperator")
                          }
                          sx={controllerDropdowns}
                        >
                          <MenuItem value={"is one of"}>Is One Of</MenuItem>
                          <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                        </Select>

                        {/* Input field for manual entry */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                          {/* TextField for manual ID entry */}
                          <TextField
                            name="category"
                            {...field}
                            value={categories || []}
                            onChange={(e) => {
                              const value = e.target.value
                                .split(",")
                                .map((v) => v.trim())
                                .filter((v) => v);
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "category");
                            }}
                            label="Enter Category ID"
                            sx={inputwithDropdown}
                          />

                          {/* Category dropdown */}
                          <Select
                            labelId="category-select-label"
                            id="category-select"
                            multiple
                            value={categories || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "category");
                            }}
                            input={<OutlinedInput label="Category" />}
                            MenuProps={MenuProps}
                            sx={dropDownWithInput}
                          >
                            {(() => {
                              const channelCategoryMap = {};

                              filteredCategories.forEach((cat) => {
                                (cat.channelId || []).forEach((cid) => {
                                  const channel = channelData.find((ch) => ch._id === cid);
                                  if (selectedChannelIds.includes(cid)) {
                                    if (!channel?.name) return;
                                    const channelName = channel.name;
                                    if (!channelCategoryMap[channelName]) channelCategoryMap[channelName] = [];
                                    channelCategoryMap[channelName].push(cat);
                                  }
                                });
                              });

                              return Object.entries(channelCategoryMap).map(([channelName, cats]) => [
                                <ListSubheader
                                  key={`header-${channelName}`}
                                  sx={{ fontWeight: "bold", color: "#00C853", mb: 1, fontSize: "1rem" }}
                                >
                                  {channelName}
                                </ListSubheader>,
                                ...cats.map((element) => (
                                  <MenuItem
                                    key={element._id}
                                    value={element._id}
                                    style={getStyles(element.name, conditionValue, theme)}
                                  >
                                    {element.name}
                                  </MenuItem>
                                )),
                              ]);
                            })()}
                          </Select>
                        </div>

                        {/* Validation Message */}
                        {conditionValue.includes("Category") && categories && categories.length == 0 ?
                          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please select at least one category</span>
                          : null}
                      </div>
                    );
                  }}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Brand") ? (
                <Controller
                  name="brand"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Brand
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={brandOperator}
                        label="Category Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "brandOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={brand}
                          onChange={(value) =>
                            handleConditionChanges(value, "brand")
                          }
                          label="Enter Category Id"
                          sx={inputwithDropdown}
                        />
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={brand}
                          onChange={(value) =>
                            handleConditionChanges(value, "brand")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={dropDownWithInput}
                        >
                          {brandDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Brand") && brand && brand.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please select at least one brand</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("AttributeSet") ? (
                <Controller
                  name="attributeSet"
                  control={control}
                  rules={{ required: "Please select at least one attribute set" }}
                  defaultValue={[]}
                  render={({ field }) => {
                    const selectedChannelAttIds = channelValue || [];
                    const filteredAttributeSet = AttributeSetDropdown.filter((attributeSet) =>
                      (attributeSet.channelId || []).some((id) =>
                        selectedChannelAttIds.includes(id.toString())
                      )

                    );

                    const groupedByChannel = {};
                    filteredAttributeSet.forEach((att) => {
                      (att.channelId || []).forEach((cid) => {
                        const channel = channelData.find((ch) => ch._id.toString() === cid.toString());
                        if (selectedChannelAttIds.includes(cid)) {
                          if (!channel?.name) return;
                          const channelName = channel.name;
                          if (!groupedByChannel[channelName]) groupedByChannel[channelName] = [];
                          groupedByChannel[channelName].push(att);
                        }
                      });
                    });

                    return (
                      <div>
                        <InputLabel sx={controllerLabel} id="attributeSet-operator-label">
                          Select Attribute Set
                        </InputLabel>

                        <Select
                          labelId="attributeSet-operator-label"
                          id="attributeSet-operator"
                          value={attributeSetOperator}
                          onChange={(value) =>
                            handleOperatorChange(value, "attributeSetOperator")
                          }
                          sx={controllerDropdowns}
                        >
                          <MenuItem value="is one of">Is One Of</MenuItem>
                          <MenuItem value="is not one of">Is Not One Of</MenuItem>
                        </Select>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          <TextField
                            name="attributeSet"
                            {...field}
                            value={attributeSet || []}
                            onChange={(e) => {
                              const value = e.target.value
                                .split(",")
                                .map((v) => v.trim())
                                .filter((v) => v);
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "attributeSet");
                            }}
                            label="Enter Attribute Set ID"
                            sx={inputwithDropdown}
                          />

                          <Select
                            labelId="attributeSet-select-label"
                            id="attributeSet-select"
                            multiple
                            value={attributeSet || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "attributeSet");
                            }}
                            input={<OutlinedInput label="Attribute Set" />}
                            MenuProps={MenuProps}
                            sx={dropDownWithInput}
                          >
                            {Object.entries(groupedByChannel).map(([channelName, items]) => [
                              <ListSubheader
                                key={`header-${channelName}`}
                                sx={{
                                  fontWeight: "bold",
                                  color: "#00C853",
                                  mb: 1,
                                  fontSize: "1rem",
                                }}
                              >
                                {channelName}
                              </ListSubheader>,
                              ...items.map((element) => (
                                <MenuItem
                                  key={element._id}
                                  value={element._id}
                                  style={getStyles(element.name, conditionValue, theme)}
                                >
                                  {element.name}
                                </MenuItem>
                              )),
                            ])}
                          </Select>
                        </div>

                        {conditionValue.includes("AttributeSet") && attributeSet && attributeSet.length == 0 ?
                          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please select at least one attribute set</span>
                          : null}
                      </div>
                    );
                  }}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              {conditionValue.includes("Sku") ? (
                <Controller
                  name="sku"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Comma Seperated Product Sku
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={skuOperator}
                        label="Sku Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "skuOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is one of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not one of</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={skus}
                          onChange={(value) => handleConditionChanges(value, "sku")}
                          label="Enter Comma Seperated Sku Id"
                          sx={controllerDropdowns}
                        // error={Boolean(errors.sku)} 
                        // helperText={errors.sku && errors.sku.message}
                        />
                      </div>
                      {conditionValue.includes("Sku") && skus && skus.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please enter at least one SKU</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {["Category", "Brand", "AttributeSet"].some((cond) => conditionValue.includes(cond)) && (
                <Controller
                  name="exclude_discounted_condition_product"
                  control={control}
                  render={({ field: { value = [], onChange, ...rest } }) => (
                    <div style={{ margin: "8px 20px" }}>
                      <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                        Exclude Discounted Products (Oracle IDs)
                      </InputLabel>
                      <TextField
                        {...rest}
                        //defaultValue={value.join(", ")}
                        defaultValue={Array.isArray(value) ? value.join(", ") : ""}
                        onBlur={(e) => {
                          const parsed = e.target.value
                            .split(",")
                            .map((id) => id.trim())
                            .filter(Boolean);
                          onChange(parsed);
                        }}

                        placeholder="Enter comma-separated Oracle IDs"
                        fullWidth
                        multiline
                        minRows={2}
                        sx={{
                          ...controllerDropdowns,
                          width: "492px",
                          margin: "0px 75px",
                          marginLeft: "60px"
                        }}
                      />
                      <span style={{ fontSize: "12px", color: "#666" }}>
                        {/* Enter Oracle IDs separated by commas */}
                      </span>
                    </div>
                  )}
                />
              )}
              {conditionValue.includes("Price") ? (
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Price
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={priceOperator}
                        label="Price Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "priceOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={price}
                          onChange={(value) =>
                            handleConditionChanges(value, "price")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {conditionValue.includes("Price") && price && price === "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Price</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Cart Price") ? (
                <Controller
                  name="cartPrice"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Total Cart Price
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={cartPriceOperator}
                        label="Cart Price Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "cartPriceOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={cartPrice}
                          onChange={(value) =>
                            handleConditionChanges(value, "cartPrice")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {conditionValue.includes("Cart Price") && cartPrice && cartPrice === "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Cart Price</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Cart Sub Total (Excl Tax)") ? (
                <Controller
                  name="cartSubTotalExclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Cart Sub Total (Excl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={cartSubTotalExclTaxOperator}
                        label="Cart Price Operator"
                        onChange={(value) => handleOperatorChange(value, "ExclTax")}
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={cartSubTotalExclTax}
                          onChange={(value) =>
                            handleConditionChanges(value, "ExclTax")
                          }
                          label="Cart Sub Total (Excl Tax)"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {conditionValue.includes("Cart Sub Total (Excl Tax)") && Number(cartSubTotalExclTax) === 0 ? (
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>Please enter Subtotal (Excluding Tax) value</span>
                      ) : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Cart Sub Total (Incl Tax)") ? (
                <Controller
                  name="cartSubTotalInclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Sub Total (Incl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={cartSubTotalInclTaxOperator}
                        label="Cart Sub Total (Incl Tax)"
                        onChange={(value) => handleOperatorChange(value, "InclTax")}
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={cartSubTotalInclTax}
                          onChange={(value) =>
                            handleConditionChanges(value, "InclTax")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {conditionValue.includes("Cart Sub Total (Incl Tax)") && Number(cartSubTotalInclTax) === 0 ? (
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Subtotal (Including Tax) value</span>
                      ) : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Total Weight") ? (
                <Controller
                  name="totalWeight"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Total Weight
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={totalWeightOperator}
                        label="Cart Total Weight"
                        onChange={(value) =>
                          handleOperatorChange(value, "totalWeight")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={totalWeight}
                          onChange={(value) =>
                            handleConditionChanges(value, "totalWeight")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {conditionValue.includes("Total Weight") && totalWeight && totalWeight === "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Total Weight</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Payment Method") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Payment Method
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={paymentMethodOperator}
                        label="Category Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "paymentMethod")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={paymentMethod}
                          onChange={(value) =>
                            handleConditionChanges(value, "paymentMethod")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {paymentMethodDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Payment Method") && paymentMethod && paymentMethod.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Payment Method</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Shipping Method") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping Method
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={shippingMethodOperator}
                        label="Shipping Method Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "shippingMethod")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={shippingMethod}
                          onChange={(value) =>
                            handleConditionChanges(value, "shippingMethod")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {shippingMethodDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Shipping Method") && shippingMethod && shippingMethod.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Shipping Method </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Shipping PostCode") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping PostCode
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={shippingPostCodeOperator}
                        label="Payment Postcode Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "shippingPostcode")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={shippingPostcode}
                          onChange={(value) =>
                            handleConditionChanges(value, "shippingPostcode")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {shippingPostCodeDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Shipping PostCode") && shippingPostcode && shippingPostcode.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Shipping Postcode </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Shipping Country") ? (
                <Controller
                  name="shippingCountry"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping Country
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={shippingCountryOperator}
                        label="Shipping Country Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "shippingCountry")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={shippingCountry}
                          onChange={(value) =>
                            handleConditionChanges(value, "shippingPostcode")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {shippingCountryDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Shipping Country") && shippingCountry && shippingCountry.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Shipping Country </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {conditionValue.includes("Shipping State") ? (
                <Controller
                  name="shippingState"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping State
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={shippingStateOperator}
                        label="Shipping State Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "shippingState")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={shippingState}
                          onChange={(value) =>
                            handleConditionChanges(value, "shippingState")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {shippingStateDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {conditionValue.includes("Shipping State") && shippingState && shippingState.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter shipping State </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              <div
                style={{ width: "100%", height: "5px", backgroundColor: "black" }}
              ></div>
              <Controller
                name="action"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Actions
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={actionValue}
                      onChange={(value) => handleChanges(value, "actionValue")}
                      onClose={(value) => loadConditionValue(value, "actionValue")}
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {namesAction.map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, actionValue, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />

              {actionValue.includes("Category") ? (
                <Controller
                  name="actionCategory"
                  control={control}
                  rules={{ required: "Please select at least one action category" }}
                  defaultValue={[]}
                  render={({ field }) => {
                    const selectedChannelActIds = channelValue || [];
                    const filteredCategories = categoryDropdownAction.filter((category) =>
                      (category.channelId || []).some((id) =>
                        selectedChannelActIds.includes(id.toString())
                      )
                    );

                    const groupedByChannel = {};
                    filteredCategories.forEach((cat) => {
                      (cat.channelId || []).forEach((cid) => {
                        const channel = channelData.find((ch) => ch._id.toString() === cid.toString());
                        if (selectedChannelActIds.includes(cid)) {
                          if (!channel?.name) return;
                          const channelName = channel.name;
                          if (!groupedByChannel[channelName]) groupedByChannel[channelName] = [];
                          groupedByChannel[channelName].push(cat);
                        }
                      });
                    });

                    return (
                      <div>
                        <InputLabel
                          sx={controllerLabel}
                          id="action-category-operator-label"
                        >
                          Select Action Category
                        </InputLabel>

                        {/* Action Category Operator */}
                        <Select
                          labelId="action-category-operator-label"
                          id="action-category-operator"
                          value={categoryOperatorAction}
                          onChange={(e) =>
                            handleOperatorChange(e, "categoryOperatorAction")
                          }
                          sx={controllerDropdowns}
                        >
                          <MenuItem value="is one of">Is One Of</MenuItem>
                          <MenuItem value="is not one of">Is Not One Of</MenuItem>
                        </Select>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          {/* Manual Input */}
                          <TextField
                            {...field}
                            value={actionCategories || []}
                            onChange={(e) => {
                              const value = e.target.value
                                .split(",")
                                .map((v) => v.trim())
                                .filter((v) => v);
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "actionCategory");
                            }}
                            label="Enter Category ID"
                            sx={inputwithDropdown}
                          />

                          {/* Dropdown */}
                          <Select
                            labelId="action-category-select"
                            id="action-category-select"
                            multiple
                            value={actionCategories || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "actionCategory");
                            }}
                            input={<OutlinedInput label="Action Category" />}
                            MenuProps={MenuProps}
                            sx={dropDownWithInput}
                          >
                            {Object.entries(groupedByChannel).map(([channelName, cats]) => [
                              <ListSubheader
                                key={`header-${channelName}`}
                                sx={{
                                  fontWeight: "bold",
                                  color: "#00C853",
                                  mb: 1,
                                  fontSize: "1rem",
                                }}
                              >
                                {channelName}
                              </ListSubheader>,
                              ...cats.map((element) => (
                                <MenuItem
                                  key={element._id}
                                  value={element._id}
                                  style={getStyles(element.name, actionValue, theme)}
                                >
                                  {element.name}
                                </MenuItem>
                              )),
                            ])}
                          </Select>
                        </div>

                        {actionValue.includes("Category") && actionCategories && actionCategories.length == 0 ?
                          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please select at least one action category</span>
                          : null}
                      </div>
                    );
                  }}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              {actionValue.includes("Brand") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Brand
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={brandOperatorAction}
                        label="Category Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "brandOperatorAction")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is"}>Is</MenuItem>
                        <MenuItem value={"is not"}>Is Not</MenuItem>
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionBrand}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionBrand")
                          }
                          label="Enter Category Id"
                          sx={inputwithDropdown}
                        />
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionBrand}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionBrand")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={dropDownWithInput}
                        >
                          {brandDropdownAction.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Brand") && actionBrand && actionBrand.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please  select at least one action brand</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("AttributeSet") ? (
                <Controller
                  name="actionAttributeSet"
                  control={control}
                  rules={{ required: "Please select at least one action attribute set" }}
                  defaultValue={[]}
                  render={({ field }) => {
                    const selectedChannelActAtrIds = channelValue || [];
                    const filteredAttributeSets = AttributeSetDropdownAction.filter((att) =>
                      (att.channelId || []).some((id) =>
                        selectedChannelActAtrIds.includes(id.toString())
                      )
                    );

                    const groupedByChannel = {};
                    filteredAttributeSets.forEach((att) => {
                      (att.channelId || []).forEach((cid) => {
                        const channel = channelData.find((ch) => ch._id.toString() === cid.toString());
                        if (selectedChannelActAtrIds.includes(cid)) {
                          if (!channel?.name) return;
                          const channelName = channel.name;
                          if (!groupedByChannel[channelName]) groupedByChannel[channelName] = [];
                          groupedByChannel[channelName].push(att);
                        }
                      });
                    });

                    return (
                      <div>
                        <InputLabel sx={controllerLabel} id="action-attributeSet-operator-label">
                          Select Attribute Set
                        </InputLabel>

                        <Select
                          labelId="action-attributeSet-operator-label"
                          id="action-attributeSet-operator"
                          value={attributeSetOperatorAction}
                          onChange={(e) =>
                            handleOperatorChange(e, "attributeSetOperatorAction")
                          }
                          sx={controllerDropdowns}
                        >
                          {/* <MenuItem value="is">Is</MenuItem>
            <MenuItem value="is not">Is Not</MenuItem> */}
                          <MenuItem value="is one of">Is One Of</MenuItem>
                          <MenuItem value="is not one of">Is Not One Of</MenuItem>
                        </Select>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "10px",
                          }}
                        >
                          {/* Manual TextField */}
                          <TextField
                            {...field}
                            value={actionAttributeSet || []}
                            onChange={(e) => {
                              const value = e.target.value
                                .split(",")
                                .map((v) => v.trim())
                                .filter((v) => v);
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "actionAttributeSet");
                            }}
                            label="Enter Attribute Set ID"
                            sx={inputwithDropdown}
                          />

                          {/* Dropdown */}
                          <Select
                            labelId="action-attributeSet-select"
                            id="action-attributeSet-select"
                            multiple
                            value={actionAttributeSet || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "actionAttributeSet");
                            }}
                            input={<OutlinedInput label="Attribute Set" />}
                            MenuProps={MenuProps}
                            sx={dropDownWithInput}
                          >
                            {Object.entries(groupedByChannel).map(([channelName, items]) => [
                              <ListSubheader
                                key={`header-${channelName}`}
                                sx={{
                                  fontWeight: "bold",
                                  color: "#00C853",
                                  mb: 1,
                                  fontSize: "1rem",
                                }}
                              >
                                {channelName}
                              </ListSubheader>,
                              ...items.map((element) => (
                                <MenuItem
                                  key={element._id}
                                  value={element._id}
                                  style={getStyles(element.name, actionValue, theme)}
                                >
                                  {element.name}
                                </MenuItem>
                              )),
                            ])}
                          </Select>
                        </div>

                        {actionValue.includes("AttributeSet") && actionAttributeSet && actionAttributeSet.length == 0 ?
                          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please  select at least one action attribute set</span>
                          : null}
                      </div>
                    );
                  }}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              {actionValue.includes("Sku") ? (
                <Controller
                  name="actionSku"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Comma Seperated Product Sku
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionSkusOperator}
                        label="Action Sku Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionSkuOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is one of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not one of</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionSkus}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionSku")
                          }
                          label="Enter Comma Seperated Sku Id"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Sku") && actionSkus && actionSkus.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter at least one action SKU</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Price") ? (
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Action Price
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionPriceOperator}
                        label="ActionPrice Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionPriceOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionPrice}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionPrice")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Price") && actionPrice && actionPrice.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Price </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Cart Price") ? (
                <Controller
                  name="actionCartPrice"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Total Cart Price
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionCartPriceOperator}
                        label="Cart Price Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionCartPriceOperator")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionCartPrice}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionCartPrice")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Cart Price") && actionCartPrice && actionCartPrice.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Cart Price </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Cart Sub Total (Excl Tax)") ? (
                <Controller
                  name="actionCartSubTotalExclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Enter Cart Sub Total (Excl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actioncartSubTotalExclTaxOperator}
                        label="Cart Sub Total Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionExclTax")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionCartSubTotalExclTax}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionExclTax")
                          }
                          label="Cart Sub Total (Excl Tax)"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Cart Sub Total (Excl Tax)") && actionCartSubTotalExclTax && actionCartSubTotalExclTax == "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Sub Total (Excl Tax) value</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Cart Sub Total (Incl Tax)") ? (
                <Controller
                  name="actionCartSubTotalInclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Sub Total (Incl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actioncartSubTotalInclTaxOperator}
                        label="Cart Sub Total (Incl Tax)"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionInclTax")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionCartSubTotalInclTax}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionInclTax")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Cart Sub Total (Incl Tax)") && actionCartSubTotalInclTax && actionCartSubTotalInclTax == "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the Action Sub Total (Incl Tax) value</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Total Weight") ? (
                <Controller
                  name="actionTotalWeight"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Total Weight
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionTotalWeightOperator}
                        label="Cart Total Weight"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionTotalWeight")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        <MenuItem value={"lte"}>Lte</MenuItem>
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={actionTotalWeight}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionTotalWeight")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {actionValue.includes("Total Weight") && actionTotalWeight && actionTotalWeight.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Total Weight </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Payment Method") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Payment Method
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionPaymentMethodOperator}
                        label="Category Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionPaymentMethod")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionPaymentMethod}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionPaymentMethod")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {actionPaymentMethodDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Payment Method") && actionPaymentMethod && actionPaymentMethod.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Payment Method </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Shipping Method") ? (
                <Controller
                  name="conditions"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping Method
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionShippingMethodOperator}
                        label="Shipping Method Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionShippingMethod")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionShippingMethod}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionShippingMethod")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {actionShippingMethodDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Shipping Method") && actionShippingMethod && actionShippingMethod.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Shipping Method </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Shipping PostCode") ? (
                <Controller
                  name="shippingPostcode"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping PostCode
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionShippingPostCodeOperator}
                        label="Payment Postcode Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionShippingPostcode")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionShippingPostcode}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionShippingPostcode")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {actionShippingPostCodeDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Shipping PostCode") && actionShippingPostcode && actionShippingPostcode.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Shipping PostCode </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Shipping Country") ? (
                <Controller
                  name="shippingCountry"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping Country
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionShippingCountryOperator}
                        label="Shipping Country Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionShippingCountry")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionShippingCountry}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionShippingPostcode")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {actionShippingCountryDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Shipping Country") && actionShippingCountry && actionShippingCountry.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Shipping Country </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {actionValue.includes("Shipping State") ? (
                <Controller
                  name="actionShippingState"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Select Shipping State
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionShippingStateOperator}
                        label="Action Shipping State Operator"
                        onChange={(value) =>
                          handleOperatorChange(value, "actionShippingState")
                        }
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"is one of"}>Is One Of</MenuItem>
                        <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                      </Select>
                      <div>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={actionsShippingState}
                          onChange={(value) =>
                            handleConditionChanges(value, "actionShippingState")
                          }
                          input={<OutlinedInput label="Name" />}
                          MenuProps={MenuProps}
                          sx={controllerDropdowns}
                        >
                          {actionShippingStateDropdown.map((element) => (
                            <MenuItem
                              key={element._id}
                              value={element._id}
                              style={getStyles(element.name, conditionValue, theme)}
                            >
                              {element.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {actionValue.includes("Shipping State") && actionsShippingState && actionsShippingState.length == 0 ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter the action Shipping State </span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {["Category", "Brand", "AttributeSet"].some((cond) => actionValue.includes(cond)) && (
                <Controller
                  name="exclude_discounted_action_product"
                  control={control}
                  render={({ field: { value = [], onChange, ...rest } }) => (
                    <div style={{ margin: "8px 20px" }}>
                      <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                        Exclude Discounted Products (Oracle IDs)
                      </InputLabel>
                      <TextField
                        {...rest}
                        //defaultValue={value.join(", ")}
                        defaultValue={Array.isArray(value) ? value.join(", ") : ""}
                        onBlur={(e) => {
                          const parsed = e.target.value
                            .split(",")
                            .map((id) => id.trim())
                            .filter(Boolean);
                          onChange(parsed);
                        }}

                        placeholder="Enter comma-separated Oracle IDs"
                        fullWidth
                        multiline
                        minRows={2}
                        sx={{
                          ...controllerDropdowns,
                          width: "492px",
                          margin: "0px 75px",
                          marginLeft: "60px"
                        }}
                      />
                      <span style={{ fontSize: "12px", color: "#666" }}>
                        {/* Enter Oracle IDs separated by commas */}
                      </span>
                    </div>
                  )}
                />
              )}
              <Controller
                name="action_rule"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Action Rules
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={applyRuleAction}
                      label="Action Rule"
                      onChange={(value) => handleChange(value, "actionRule")}
                      sx={controllerDropdowns}
                    >
                      {actionRules.map((element) => (
                        <MenuItem key={element} value={element}>
                          {element}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="Discount In Percentage"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Discount In Percentage
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={isPercentage}
                      label="Discount In Percentage"
                      onChange={(value) => handleChange(value, "isPercentage")}
                      sx={controllerDropdowns}
                    >
                      {/* {actionRules.map((element) => ( */}
                      <MenuItem key={true} value={true}>
                        true
                      </MenuItem>
                      <MenuItem key={false} value={false}>
                        false
                      </MenuItem>
                      {/* ))} */}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="discountAmountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                    Discount Amount
                  </InputLabel> */}
                    <TextField
                      {...field}
                      label="Enter Discount Amount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              
              <Controller
                name="totalAmountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Discount Amount
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Enter Total Amount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              
              {/* <Controller
                name="maxDiscountAmountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
           isko comment karna hai         <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                    Discount Amount
                  </InputLabel>
                    <TextField
                      {...field}
                      label="Enter Maximum Discount Amount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              /> */}
              <Controller
                name="maxQtyXAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Maximum Qty Action X
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Maximum Qty Action X"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              
              <Controller
                name="maxQtyYAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Maximum Qty Action Y
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Maximum Qty Action Y"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              
              <div
                style={{
                  width: "100%",
                  height: "5px",
                  backgroundColor: "black",
                  marginTop: "50px",
                }}
              ></div>
            </>
          )}
        </div>
        <div>
          {couponProvider === 'NASHNAK' && (
            <>
              <Controller
                name="coupon_type"
                control={control}
                defaultValue="GENERIC" // Set default value for EASYREWARD
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="coupon-type-label">
                      Coupon Type
                    </InputLabel>
                    <Select
                      {...field}
                      labelId="coupon-type-label"
                      id="coupon-type-select"
                      value={field.value || "GENERIC"} // Always default to GENERIC
                      onChange={(event) => handleTypeChange(event, field)}
                      label="Coupon Type"
                      sx={controllerDropdowns}
                    >
                      <MenuItem value="GENERIC">GENERIC</MenuItem>
                      <MenuItem value="SPECIAL">SPECIAL</MenuItem>
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="active"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Active
                    </InputLabel>
                    <Switch {...field} label="Active" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="visibleOnCouponList"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Visible on Coupon List
                    </InputLabel>
                    <Switch {...field} label="visible" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ margin: "500px" }}
              />
              <Controller
                name="onlyforApp"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Apply for App
                    </InputLabel>
                    <Switch {...field} label="Apply for App" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ margin: "500px" }}
              />
              <Controller
                name="showInPdpPage"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Show in PDP Page
                    </InputLabel>
                    <Switch {...field} label=" Show in PDP Page" sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="autoApplyCoupon"
                control={control}
                defaultValue={false}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="auto-apply-coupon-label">
                      Auto Apply Coupon
                    </InputLabel>
                    <Switch {...field} checked={field.value} sx={controllerSwitch} />
                  </div>
                )}
                sx={{ width: "500px" }}
              />

              <Controller
                name="priority"
                control={control}
                defaultValue={0}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="priority-select-label">
                      Priority
                    </InputLabel>
                    <Select
                      {...field}
                      labelId="priority-select-label"
                      id="priority-select"
                      label="Priority"
                      sx={controllerDropdowns}
                    >
                      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ width: "500px" }}
              />
              <Controller
                name="rule_name"
                control={control}
                rules={{ required: "Rule Name is required*" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Rule Name
                </InputLabel> */}
                    <TextField {...field} label="Rule Name" sx={{ ...controllerFields, paddingBottom: "0px" }}
                    // error={Boolean(errors.rule_name)} 
                    // helperText={errors.rule_name && errors.rule_name.message}
                    />

                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.rule_name && errors.rule_name.message}</span>
              <Controller
                name="coupon_code"
                control={control}
                rules={{ required: "Coupon Code is required*",
                          validate: (value) => value?.trim() ? true : "Coupon Code is required*",
                 }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      onBlur={(e) => {field.onChange(("" + e.target.value).toUpperCase().trim());
                      setValue( "coupon_code",("" + e.target.value).toUpperCase().trim(),{shouldValidate: true,shouldDirty: true,});
                      field.onBlur();
                      }}   
                      onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
                      label="Coupon Code"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.coupon_code && errors.coupon_code.message}</span>
              <Controller
                name="promo_code"
                control={control}
                rules={{ required: "Promo Code is required*" }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
                      label="Promo Code"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.promo_code && errors.promo_code.message}</span>
              <Controller
                name="desc_en"
                control={control}
                //rules={{ required: true }}
                rules={{ required: "English Description is required" }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      label="English Description"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
             <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_en && errors.desc_en.message}</span>
              <Controller
                name="desc_ar"
                control={control}
              //rules={{ required: true }} 
                rules={{ required: "Arabic Description is required" }}
                render={({ field }) => (
                  <div>
                    <TextField
                      {...field}
                      label="Arabic Description"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
             <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.desc_ar && errors.desc_ar.message}</span>
              <Controller
                name="error_en"
                control={control}
                //rules={{ required: true }}
                //rules={{ required: "English Error Message is required" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message En
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="English Error Message"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
            <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.error_en && errors.error_en.message}</span>
              <Controller
                name="error_ar"
                control={control}
                //rules={{ required: true }}
                //rules={{ required: "Arabic Error Message is required" }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                  Error Message Ar
                </InputLabel> */}
                    <TextField
                      {...field}
                      label="Arabic Error Message"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
            <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {errors.error_ar && errors.error_ar.message}</span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="fromDate"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DateTimePicker
                      // label="From Date"
                      inputFormat="MM/DD/YYYY , HH:mm:ss"
                      value={fromDate}
                      disablePast
                      onChange={(date) => handleChange(date, "fromDate")}
                      renderInput={(params) => (
                        <div>
                          <InputLabel
                            sx={controllerLabel}
                            id="demo-simple-select-label"
                          >
                            From Date
                          </InputLabel>
                          <TextField {...params} sx={controllerFields} />
                        </div>
                      )}
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                  name="toDate"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <DateTimePicker
                      inputFormat="MM/DD/YYYY , HH:mm:ss"
                      value={toDate}
                      disablePast
                      minDateTime={fromDate}
                      onChange={(date) => handleChange(date, "toDate")}
                      renderInput={(params) => (
                        <div>
                          <InputLabel
                            sx={controllerLabel}
                            id="demo-simple-select-label"
                          >
                            To Date
                          </InputLabel>
                          <TextField {...params} sx={controllerFields} />
                        </div>
                      )}

                    />

                  )}
                />
              </LocalizationProvider>
              {toDateError && <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>{toDateError}</span>}
               <Controller
                name="channel"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Channel
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={channelValue}
                      onChange={(value) => handleChannelChanges(value)}
                      // value={field.value || []}
                      // onChange={(e) => {
                      //   // field.onChange(e.target.value);
                      //   // setChannelValue(e.target.value);
                      //   handleChannelChanges(e);
                      // }}
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {channelData.map((name) => (
                        <MenuItem key={name._id} value={name._id}>
                          {name.name}
                        </MenuItem>
                      ))}

                    </Select>
                    {channelValue && channelValue.length === 0 && (
                      <p style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> {channelError}</p>
                    )}
                  </div>

                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="conditions"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                      Condition
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={conditionValue}
                      onChange={(value) => handleChanges(value, "conditionValue")}
                      onClose={(value) =>
                        loadConditionValue(value, "conditionValue")
                      }
                      input={<OutlinedInput label="Name" />}
                      MenuProps={MenuProps}
                      sx={controllerDropdowns}
                    >
                      {/* {names.filter((name) => name === "Cart Sub Total (Incl Tax)" || name === "Category").map((name) => ( */}
                      {names.filter((name) => name === "Cart Sub Total (Incl Tax)").map((name) => (
                        <MenuItem
                          key={name}
                          value={name}
                          style={getStyles(name, conditionValue, theme)}
                        >
                          {name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {conditionValue.includes("Cart Sub Total (Incl Tax)") ? (
                <Controller
                  name="cartSubTotalInclTax"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <div>
                      <InputLabel
                        sx={controllerLabel}
                        id="demo-multiple-name-label"
                      >
                        Cart Sub Total (Incl Tax)
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={cartSubTotalInclTaxOperator}
                        label="Cart Sub Total (Incl Tax)"
                        onChange={(value) => handleOperatorChange(value, "InclTax")}
                        sx={controllerDropdowns}
                      >
                        <MenuItem value={"eq"}>Eq</MenuItem>
                        <MenuItem value={"gte"}>Gte</MenuItem>
                        {/* <MenuItem value={"lte"}>Lte</MenuItem> */}
                      </Select>
                      <div>
                        <TextField
                          {...field}
                          value={cartSubTotalInclTax}
                          onChange={(value) =>
                            handleConditionChanges(value, "InclTax")
                          }
                          label="price"
                          sx={controllerDropdowns}
                        />
                      </div>
                      {cartSubTotalInclTax.length === 0 && (
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px', marginBottom: '0px' }}>
                          Please enter Subtotal (Including Tax) value</span>
                      )}
                      {conditionValue.includes("Cart Sub Total (Incl Tax)") && cartSubTotalInclTax && cartSubTotalInclTax === "0" ?
                        <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}> Please enter Subtotal (Including Tax) value</span>
                        : null}
                    </div>
                  )}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}

              {conditionValue.includes("Category") ? (
                <Controller
                  name="category"
                  control={control}
                  rules={{ required: "Please enter category value" }}
                  defaultValue={[]}
                  render={({ field }) => {
                    const selectedChannelIds = channelValue || [];
                    const filteredCategories = categoryDropdown.filter((category) =>
                      category.channelId?.some((id) => selectedChannelIds.includes(id))
                    );

                    return (
                      <div>
                        <InputLabel sx={controllerLabel} id="category-operator-label">
                          Select Category
                        </InputLabel>

                        {/* Category Operator */}
                        <Select
                          labelId="category-operator-label"
                          id="category-operator"
                          value={categoryOperator}
                          label="Category Operator"
                          onChange={(value) =>
                            handleOperatorChange(value, "categoryOperator")
                          }
                          sx={controllerDropdowns}
                        >
                          <MenuItem value={"is one of"}>Is One Of</MenuItem>
                          <MenuItem value={"is not one of"}>Is Not One Of</MenuItem>
                        </Select>

                        {/* Input field for manual entry */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                          {/* TextField for manual ID entry */}
                          <TextField
                            name="category"
                            {...field}
                            value={categories || []}
                            onChange={(e) => {
                              const value = e.target.value
                                .split(",")
                                .map((v) => v.trim())
                                .filter((v) => v);
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "category");
                            }}
                            label="Enter Category ID"
                            sx={inputwithDropdown}
                          />

                          {/* Category dropdown */}
                          <Select
                            labelId="category-select-label"
                            id="category-select"
                            multiple
                            value={categories || []}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleConditionChanges({ target: { value } }, "category");
                            }}
                            input={<OutlinedInput label="Category" />}
                            MenuProps={MenuProps}
                            sx={dropDownWithInput}
                          >
                            {(() => {
                              const channelCategoryMap = {};

                              filteredCategories.forEach((cat) => {
                                (cat.channelId || []).forEach((cid) => {
                                  const channel = channelData.find((ch) => ch._id === cid);
                                  if (selectedChannelIds.includes(cid)) {
                                    if (!channel?.name) return;
                                    const channelName = channel.name;
                                    if (!channelCategoryMap[channelName]) channelCategoryMap[channelName] = [];
                                    channelCategoryMap[channelName].push(cat);
                                  }
                                });
                              });

                              return Object.entries(channelCategoryMap).map(([channelName, cats]) => [
                                <ListSubheader
                                  key={`header-${channelName}`}
                                  sx={{ fontWeight: "bold", color: "#00C853", mb: 1, fontSize: "1rem" }}
                                >
                                  {channelName}
                                </ListSubheader>,
                                ...cats.map((element) => (
                                  <MenuItem
                                    key={element._id}
                                    value={element._id}
                                    style={getStyles(element.name, conditionValue, theme)}
                                  >
                                    {element.name}
                                  </MenuItem>
                                )),
                              ]);
                            })()}
                          </Select>
                        </div>
                        {conditionValue.includes("Category") && categories && categories.length == 0 ?
                          <span style={{ color: "red", marginLeft: "5%", marginTop: '0px !important', marginBottom: '0px !important' }}>  Please select at least one category</span>
                          : null}
                      </div>
                    );
                  }}
                  sx={{ margin: "0px 30px" }}
                />
              ) : null}
              {["Category"].some((cond) => conditionValue.includes(cond)) && (
                <Controller
                  name="exclude_discounted_condition_product"
                  control={control}
                  render={({ field: { value = [], onChange, ...rest } }) => (
                    <div style={{ margin: "8px 20px" }}>
                      <InputLabel sx={controllerLabel} id="demo-multiple-name-label">
                        Exclude Discounted Products (Oracle IDs)
                      </InputLabel>
                      <TextField
                        {...rest}
                        //  defaultValue={value.join(", ")}
                        defaultValue={Array.isArray(value) ? value.join(", ") : ""}
                        onBlur={(e) => {
                          const parsed = e.target.value
                            .split(",")
                            .map((id) => id.trim())
                            .filter(Boolean);
                          onChange(parsed);
                        }}
                        placeholder="Enter comma-separated Oracle IDs"
                        fullWidth
                        multiline
                        minRows={2}
                        sx={{
                          ...controllerDropdowns,
                          width: "492px",
                          margin: "0px 75px",
                          marginLeft: "60px"
                        }}
                      />
                      <span style={{ fontSize: "12px", color: "#666" }}>
                        {/* Enter Oracle IDs separated by commas */}
                      </span>
                    </div>
                  )}
                />
              )}
              <Controller
                name="action_rule"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Action Rules
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={applyRuleAction}
                      label="Action Rule"
                      onChange={(value) => handleChange(value, "actionRule")}
                      sx={controllerDropdowns}
                    >
                      {/* {actionRules.map((element) => (
                    <MenuItem key={element} value={element}>
                      {element}
                    </MenuItem>
                  ))}
                </Select> */}
                      {filteredActionRules && filteredActionRules.length > 0 ? (
                        filteredActionRules.map((element) => (
                          <MenuItem key={element} value={element}>
                            {element}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No Action Rules Available</MenuItem>
                      )}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="Discount In Percentage"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                      Discount In Percentage
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={isPercentage}
                      label="Discount In Percentage"
                      onChange={(value) => handleChange(value, "isPercentage")}
                      sx={controllerDropdowns}
                    >
                      {/* {actionRules.map((element) => ( */}
                      <MenuItem key={true} value={true}>
                        true
                      </MenuItem>
                      <MenuItem key={false} value={false}>
                        false
                      </MenuItem>
                      {/* ))} */}
                    </Select>
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <Controller
                name="discountAmountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                    Discount Amount
                  </InputLabel> */}
                    <TextField
                      {...field}
                      label="Enter Discount Amount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              {/* <Controller
                name="minAmountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                    Discount Amount
                  </InputLabel> */}
                    {/* <TextField
                      {...field}
                      label="Minimum Amount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }} */}
              {/* /> */} 
              <Controller
                name="maxDiscountAction"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div>
                    {/* <InputLabel sx={controllerLabel} id="demo-simple-select-label">
                    Discount Amount
                  </InputLabel> */}
                    <TextField
                      {...field}
                      label="Maximum Discount"
                      sx={controllerFields}
                    />
                  </div>
                )}
                sx={{ margin: "0px 30px" }}
              />
              <div
                style={{
                  width: "100%",
                  height: "5px",
                  backgroundColor: "black",
                  marginTop: "50px",
                }}
              ></div>
            </>

          )}

        </div>
      </form>

    </React.Fragment>
  );
}

export default AddCoupon;
